import React, { FC } from "react";
import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTranslation } from "react-i18next";

interface DMSurveySuccessProps {
  submittedAt: string;
}

export const DMSurveySuccess: FC<DMSurveySuccessProps> = ({ submittedAt }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ bgcolor: "rgba(248, 248, 248, 1)", minHeight: "100vh", py: 8 }}>
      <Container maxWidth="sm">
        <Paper elevation={1} sx={{ p: 6, textAlign: "center" }}>
          <Stack spacing={3} alignItems="center">
            <CheckCircleIcon sx={{ fontSize: "8rem", color: "success.main" }} />
            <Typography variant="h4" fontWeight={600}>
              {t("dmSurvey.thankYou", "Thank You!")}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t(
                "dmSurvey.submittedMessage",
                "Your survey has been successfully submitted. We appreciate your valuable feedback.",
              )}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t("dmSurvey.submittedAt", "Submitted on {{date}}", {
                date: new Date(submittedAt).toLocaleString(),
              })}
            </Typography>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};
